import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { registerWorker } from '../../utils/registerWorker';
import { urlB64ToUint8Array } from '../../utils/base64_to_uint8_array';
import { registerEndpoint } from '../../services/registerEndpoint/registerEndpoint';
import { prepareSubscription } from '../../utils/prepareSubscription';
export var PopupManager = /*#__PURE__*/_createClass(function PopupManager(props) {
  var _this = this;
  _classCallCheck(this, PopupManager);
  _defineProperty(this, "workerSrc", void 0);
  _defineProperty(this, "applicationServerKey", void 0);
  _defineProperty(this, "httpApi", void 0);
  _defineProperty(this, "serviceWorkerRegistration", null);
  _defineProperty(this, "register", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return registerWorker(_this.workerSrc);
        case 2:
          _this.serviceWorkerRegistration = _context.sent;
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  _defineProperty(this, "subscribe", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var subscription, preparedSubscription;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!_this.serviceWorkerRegistration) {
            _context2.next = 11;
            break;
          }
          _context2.next = 3;
          return _this.serviceWorkerRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array(_this.applicationServerKey)
          });
        case 3:
          subscription = _context2.sent;
          preparedSubscription = prepareSubscription(subscription);
          if (!preparedSubscription) {
            _context2.next = 10;
            break;
          }
          _context2.next = 8;
          return registerEndpoint(_this.httpApi, preparedSubscription, true);
        case 8:
          _context2.next = 11;
          break;
        case 10:
          throw new Error('Unable to get subscription data from pushManager');
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  this.workerSrc = props.workerSrc;
  this.applicationServerKey = props.applicationServerKey;
  this.httpApi = props.httpApi;
});